module.exports = __webpack_public_path__ + "img/banner.3af40622.jpg";